export default "__VITE_ASSET__e0a69d25__"